module.exports = __webpack_public_path__ + "static/media/icon.email.9aa1d5be.svg";